import jsPDF from "jspdf";
import "../../../../assets/font/THSarabunNew-normal";
import "../../../../assets/font/THSarabunNew-bold";
import dayjs from "dayjs";
import logoMoney from "../../closingBalance/modelPrint/ONELeasing_transparent.png";
import Background from "../../closingBalance/modelPrint/ONELeasing_Watermark.png";
import JsBarcode from "jsbarcode";

const QRCODE_URL = "https://apimobile-539174983798.asia-southeast1.run.app";

// ─── helpers ────────────────────────────────────────────────
const str = (v) => (v === null || v === undefined ? "" : String(v));
const num = (v) => (Number.isFinite(parseFloat(v)) ? parseFloat(v) : 0);

// formatter เดียวกับหน้าจอ PrintCcb (1,234.56)
const currencyFormatOne = (amount) =>
  Number(amount)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, "$&,");

// โหลดรูปจาก URL / imported asset -> dataURL (จำเป็นสำหรับ pdf.addImage)
const urlToDataURL = (url) =>
  new Promise((resolve) => {
    if (!url) return resolve(null);
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth || 300;
        canvas.height = img.naturalHeight || 300;
        canvas.getContext("2d").drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      } catch {
        resolve(null);
      }
    };
    img.onerror = () => resolve(null);
    img.src = url;
  });

const genBarcode = (value, opts = {}) => {
  if (!value) return null;
  try {
    const canvas = document.createElement("canvas");
    JsBarcode(canvas, String(value), {
      format: "CODE128",
      displayValue: false, // true = โชว์ตัวเลขใต้บาร์โค้ด
      margin: 0,
      height: 60,
      width: 2,
      ...opts,
    });
    return canvas.toDataURL("image/png");
  } catch {
    return null;
  }
};

export const BillCloseContno = async (
  dataDefault,
  payment,
  arothrData,
  dateLoad,
  dataContno,
) => {
  // ── ดึง/กันค่า null ทั้งหมด (กัน crash) ──
  const m = dataDefault || {};
  const payArr = Array.isArray(payment) ? payment : [];
  const pay = (m.cal && m.cal[0]) || {};
  const judge = (m.judge && m.judge[0]) || {};
  const cust = dataContno?.CUSTOMER || {};
  const addr = cust.ADDRESS?.[0] || {};
  const mort = dataContno?.MORTGAGE || {};
  const loan = dataContno?.LOAN || {};

  const totalPaidArr = payArr?.reduce(
    (sum, r) => sum + Number(r.PAY_BEEYPUP || 0),
    0,
  );
  const totalBeeypupArr = payArr?.reduce(
    (sum, r) => sum + Number(r.BEEYPUP || 0),
    0,
  );

  const totalBeeypupUse = totalBeeypupArr - totalPaidArr;

  const printDate = dayjs().format("DD/MM/YYYY");
  const requestDate = dateLoad ? dayjs(dateLoad).format("DD/MM/YYYY") : "";
  // หมดอายุ = วันที่ขอ + 7 วัน (ถ้าไม่ต้องการบวก ให้ลบ .add(7,"day") ออก)
  const expireDate = dateLoad ? dayjs(dateLoad).format("DD/MM/YYYY") : "";

  // ── QR: ประกอบ URL (กัน newContno undefined) ──
  const sumAmount = num(Number(pay.closingbalance) + Number(totalBeeypupUse));
  const ref1 = "001";
  let ref2 = str(judge.newContno);
  ref2 = ref2.replace(/^[A-Za-z]/, "86").replace(/-/g, "");
  const amt = Math.round(sumAmount * 100); // หน่วยสตางค์
  const qrBankUrl = ref2
    ? `${QRCODE_URL}/loans/qr/0405559001925/00/${ref1}/${ref2}/${amt}`
    : "";
  const qrCounterUrl = ref2
    ? `${QRCODE_URL}/loans/qr/0405552000435/00/${ref1}/${ref2}/${amt}`
    : "";

  // ── โหลดรูปทั้งหมดเป็น dataURL พร้อมกัน (โลโก้ + ลายน้ำ + QR) ──
  const [logoImg, wmImg, qrBankImg, qrCounterImg] = await Promise.all([
    urlToDataURL(logoMoney),
    urlToDataURL(Background),
    urlToDataURL(qrBankUrl),
    urlToDataURL(qrCounterUrl),
  ]);

  // ── pdf setup ──
  const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const setF = (style = "normal", size = 12) => {
    pdf.setFont("THSarabunNew", style);
    pdf.setFontSize(size);
  };
  const C = {
    gray: [110, 110, 110],
    line: [205, 205, 210],
    accent: [232, 120, 24],
    red: [214, 40, 40],
    dark: [40, 40, 40],
  };
  const black = () => pdf.setTextColor(0, 0, 0);

  const pageW = 210;
  const pageH = 297;
  const mL = 12;
  const mR = 12;
  const xR = pageW - mR;

  // ── ลายน้ำ: เต็มหน้า A4 + จาง (วาดก่อน = อยู่ชั้นล่างสุด) ──
  if (wmImg) {
    try {
      pdf.saveGraphicsState();
      pdf.setGState(new pdf.GState({ opacity: 0.08 })); // 0 = จางสุด, 1 = ทึบ
      pdf.addImage(wmImg, "PNG", 0, 0, pageW, pageH);
      pdf.restoreGraphicsState();
    } catch {
      /* jsPDF เก่าไม่รองรับ GState — ข้ามลายน้ำ */
    }
  }

  const row = (lblX, valX, y, label, value, o = {}) => {
    setF("normal", o.size ?? 12);
    pdf.setTextColor(...(o.lblColor ?? C.gray));
    pdf.text(`${label} :`, lblX, y, { align: "right" });
    setF(o.bold ? "bold" : "normal", o.vSize ?? o.size ?? 12);
    pdf.setTextColor(...(o.color ?? [0, 0, 0]));
    pdf.text(str(value), valX, y, { align: "left" });
    black();
  };
  const box = (x, y, w, h) => {
    pdf.setDrawColor(...C.line);
    pdf.setLineWidth(0.4);
    pdf.roundedRect(x, y, w, h, 3, 3, "S");
  };
  const sectionTitle = (text, x, y, endX) => {
    setF("bold", 14);
    pdf.setTextColor(...C.dark);
    pdf.text(text, x, y);
    const tw = pdf.getTextWidth(text);
    pdf.setDrawColor(...C.line);
    pdf.setLineWidth(0.4);
    pdf.line(x + tw + 3, y - 1.4, endX, y - 1.4);
    black();
  };

  // ── 1) Title + dates ──
  setF("bold", 20);
  pdf.text("ใบขออนุมัติยอดปิดบัญชี", pageW / 2, 16, { align: "center" });
  setF("normal", 11);
  pdf.setTextColor(...C.gray);
  pdf.text(`วันที่พิมพ์: ${printDate}`, xR, 12, { align: "right" });
  pdf.text(`วันที่ขอ: ${requestDate}`, xR, 17, { align: "right" });
  setF("bold", 11);
  pdf.setTextColor(...C.red);
  const expTxt = `ใบนี้หมดอายุวันที่: ${expireDate}`;
  pdf.text(expTxt, xR, 22, { align: "right" });
  const expW = pdf.getTextWidth(expTxt);
  pdf.setDrawColor(...C.red);
  pdf.setLineWidth(0.3);
  pdf.line(xR - expW, 23.2, xR, 23.2);
  black();

  // ── 2) Logo + company (รวมเป็นชุดเดียว ไม่ซ้อนกัน) ──
  if (logoImg) pdf.addImage(logoImg, "PNG", mL, 26, 32, 20);
  const coX = mL + 38;
  setF("bold", 13);
  pdf.setTextColor(...C.dark);
  pdf.text("บริษัท วัน มันนี่ จำกัด (สำนักงานใหญ่)", coX, 31);
  setF("normal", 11);
  pdf.setTextColor(...C.gray);
  pdf.text(
    "89 ม.14 ถ.มิตรภาพ ต.ในเมือง อ.เมืองขอนแก่น จ.ขอนแก่น 40000",
    coX,
    37,
  );
  pdf.text("043-239-888", coX, 42);
  black();

  // ── 3) ข้อมูลลูกค้า ──
  sectionTitle("ข้อมูลลูกค้า", mL, 56, xR);
  box(mL, 59, xR - mL, 30);
  const lLbl = 52,
    lVal = 55;
  const custName = [cust.SNAM, cust.NAME1, cust.NAME2]
    .map(str)
    .filter(Boolean)
    .join(" ");
  const custAddr = [addr.ADDR1, addr.TUMB, addr.AUMPDES, addr.PROVDES, addr.ZIP]
    .map(str)
    .filter(Boolean)
    .join(" ");
  row(lLbl, lVal, 67, "ชื่อลูกค้า", custName);
  setF("normal", 12);
  pdf.setTextColor(...C.gray);
  pdf.text("ที่อยู่ :", lLbl, 74, { align: "right" });
  black();
  setF("normal", 12);
  pdf.text(pdf.splitTextToSize(custAddr, 48), lVal, 74);
  row(lLbl, lVal, 85, "เบอร์ติดต่อ", addr.TELP);
  const rLbl = 150,
    rVal = 153;
  row(rLbl, rVal, 67, "เลขที่สัญญา", judge.newContno, {
    color: C.red,
    bold: true,
  });
  row(
    rLbl,
    rVal,
    74,
    "วันที่ทำสัญญา",
    judge.SDATE ? dayjs(judge.SDATE).format("DD/MM/YYYY") : "",
  );

  // ── 4) ข้อมูลสัญญา (ซ้าย) + รายละเอียดการชำระ (ขวา) ──
  const colGap = 4;
  const colW = (xR - mL - colGap) / 2;
  const lX = mL;
  const rX = mL + colW + colGap;
  sectionTitle("ข้อมูลสัญญา", lX, 98, lX + colW);
  sectionTitle("รายละเอียดการชำระ", rX, 98, rX + colW);
  const bBoxY = 101,
    bBoxH = 150;
  box(lX, bBoxY, colW, bBoxH);
  box(rX, bBoxY, colW, bBoxH);

  const totalPaid =
    num(pay.SUM_PAYAMT_N) +
    num(pay.SUM_PAYAMT_V) +
    num(pay.SUM_PAYAMT_N_COS) +
    num(pay.SUM_PAYAMT_V_COS) +
    num(pay.SMPAY_AROTHR);

  const sumBeeypup = payArr.reduce((s, r) => s + Number(r.BEEYPUP || 0), 0);
  const sumPayBeeypup = payArr.reduce(
    (s, r) => s + Number(r.PAY_BEEYPUP || 0),
    0,
  );
  const totalBeeypup = sumBeeypup - sumPayBeeypup;

  // กล่องซ้าย
  const Llbl = lX + colW * 0.5;
  const Lval = lX + colW * 0.5 + 3;
  let y = 113;
  const stepL = 14;
  [
    ["สาขา", str(loan.LOCAT)],
    ["ยี่ห้อ", str(mort.TYPE)],
    [
      "ทะเบียน/เลขที่ดิน",
      [mort.REGNO, mort.DORECV].map(str).filter(Boolean).join(" "),
    ],
    ["รุ่น", str(mort.MODEL)],
    ["เลขตัวถัง/เลขโฉนด", str(mort.STRNO)],
    ["สี", str(mort.COLOR)],
    ["เลขเครื่อง", str(mort.ENGNO)],
    ["ยอดเงินพิพากษา", currencyFormatOne(judge.totalJugde)],
    m.flagLoanNew === 2
      ? ["ชำระเงินต้นแล้ว", currencyFormatOne(totalPaid)]
      : ["ชำระเงินต้นแล้ว", currencyFormatOne(totalPaid - sumPayBeeypup)],
  ].forEach(([l, v, o]) => {
    row(Llbl, Lval, y, l, v, o || {});
    y += stepL;
  });

  // กล่องขวา
  const interest = num(pay.calInterest) + num(pay.calInterestCost);

  const Rlbl = rX + colW * 0.62;
  const Rval = rX + colW * 0.62 + 3;
  let ry = 113;
  const stepR = 13;
  [
    ["เงินต้นคงเหลือ", currencyFormatOne(pay.TONBALANCE)],
    ["ค่าขาดประโยชน์", currencyFormatOne(pay.LACK_BALANCE)],
    ["ลูกหนี้อื่นๆ", currencyFormatOne(pay.AROTHR)],
    m.flagLoanNew === 2
      ? ["ดอกเบี้ย", currencyFormatOne(interest)]
      : ["เบี้ยปรับ", currencyFormatOne(totalBeeypup)],
    ["ส่วนลด", currencyFormatOne(0)],
  ].forEach(([l, v]) => {
    row(Rlbl, Rval, ry, l, v);
    ry += stepR;
  });

  // รวมยอด
  ry += 2;
  pdf.setDrawColor(...C.line);
  pdf.setLineWidth(0.3);
  pdf.line(rX + 6, ry - 6, rX + colW - 6, ry - 6);
  setF("bold", 14);
  pdf.setTextColor(...C.dark);
  pdf.text("รวมยอดที่ลูกค้าต้องจ่าย :", Rlbl, ry, { align: "right" });
  setF("bold", 16);
  pdf.setTextColor(...C.red);

  m.flagLoanNew === 2
    ? pdf.text(currencyFormatOne(pay.closingbalance), Rval, ry, {
        align: "left",
      })
    : pdf.text(
        currencyFormatOne(
          Number(pay.closingbalance || 0) + Number(totalBeeypup || 0),
        ),
        Rval,
        ry,
        {
          align: "left",
        },
      );
  black();

  // QR
  const qy = ry + 12;
  setF("bold", 12);
  pdf.setTextColor(...C.dark);
  pdf.text("** QRCode สำหรับจ่ายเงิน **", rX + colW / 2, qy, {
    align: "center",
  });
  black();
  const qSize = 26;
  const cBank = rX + colW * 0.28;
  const cCounter = rX + colW * 0.72;
  setF("normal", 11);
  pdf.text("ชำระผ่านธนาคาร", cBank + 20, qy + 6, { align: "center" });
  // pdf.text("ชำระผ่านธนาคาร", cBank, qy + 6, { align: "center" });
  // pdf.text("ชำระผ่านธนาคารช่องทางที่ 2", cCounter, qy + 6, {
  //   align: "center",
  // });
  const qImgY = qy + 9;
  // if (qrBankImg)
  //   pdf.addImage(qrBankImg, "PNG", cBank - qSize / 2, qImgY, qSize, qSize);
  // else {
  //   pdf.setDrawColor(...C.line);
  //   pdf.rect(cBank - qSize / 2, qImgY, qSize, qSize);
  // }
  // if (qrCounterImg)
  //   pdf.addImage(
  //     qrCounterImg,
  //     "PNG",
  //     cCounter - qSize / 2,
  //     qImgY,
  //     qSize,
  //     qSize,
  //   );
  // else {
  //   pdf.setDrawColor(...C.line);
  //   pdf.rect(cCounter - qSize / 2, qImgY, qSize, qSize);
  // }
  if (qrCounterImg)
    pdf.addImage(
      m?.lawsult?.COMPANY_ID === 1 || m?.lawsult?.COMPANY_ID === 4
        ? qrBankImg
        : qrCounterImg,
      "PNG",
      cCounter - 32,
      qImgY,
      qSize,
      qSize,
    );
  else {
    pdf.setDrawColor(...C.line);
    pdf.rect(cCounter - 32, qImgY, qSize, qSize);
  }

  // ── 5) ช่องลงนาม ──
  const sigY = 258,
    sigH = 24,
    sigW = 58,
    sigGap = 6;
  ["ผู้ซื้อ (ลูกค้า)", "ผู้ตรวจสอบ", "ผู้อนุมัติ"].forEach((label, i) => {
    const sx = mL + i * (sigW + sigGap);
    pdf.setDrawColor(...C.line);
    pdf.setLineWidth(0.4);
    pdf.roundedRect(sx, sigY, sigW, sigH, 2, 2, "S");
    setF("normal", 12);
    pdf.setTextColor(...C.dark);
    pdf.text(label, sx + sigW / 2, sigY + sigH + 5, { align: "center" });
    black();
  });

  // ── เปิด / สั่งพิมพ์ ──
  const blob = pdf.output("blob");
  const url = URL.createObjectURL(blob);
  const win = window.open(url);
  if (win) win.onload = () => win.print();
  else alert("กรุณาปิดการบล็อกป๊อปอัปเพื่อใช้งานฟังก์ชันนี้");
};
